import React, { useState, Fragment, useRef } from "react";
import { NavLink } from "react-router-dom";
import Footer from "../../component/Other/Footer";
import Navbar from "../../component/Other/Navbar";
import SecBlog from "../../component/Page/SecBlog";
import SecContact from "../../component/Page/SecContact";
import GoogleReviewsWidget from "../../component/Other/GoogleReviewsWidget";

const LandingAlt = () => {
  const video = useRef(null)
  const [play, setPlay] = useState(false)

  const serviceList = [
    {
      title: "Topfpflanzen",
      desc: "Gesunde Pflanzen für Haus und Garten. Fikusse, Monsteren, Palmen und viele andere Sorten, die jedes Interieur verschönern.",
      link: "/service/detail"
    },
    {
      title: "Gartenzubehör",
      desc: "Alles für die Pflanzenpflege. Stilvolle Töpfe, Gartengeräte und professionelle Pflegeprodukte für gesunde Pflanzen.",
      link: "/service/detail"
    },
    {
      title: "Saisonale Dekorationen", 
      desc: "Dekorationen für jede Jahreszeit. Weihnachtskompositionen, Frühlingssträuße und Herbstdekorationen das ganze Jahr über.",
      link: "/service/detail"
    },
  ];

  return (
    <Fragment>
      <div className="overflow-hidden">
        <div className="position-relative">
          <Navbar />

          <img src="./../images/Group 4.png" className="images__leaf-1" alt="" />
          <img src="./../images/Clip path group.png" className="images__leaf-2 d-none d-md-block" alt="" />
          <img src="./../images/Group 23.png" className="images__ornamen-head d-none d-md-block" alt="" />

          <section id="home" className="position-relative z-2">
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <h1 className="normal font__size--70 text__70-1024 text__70-md text__70-sm mb-3">Dein Gartencenter in Duisburg</h1>
                  <p className="normal font__size--14 text__14-1024 color__gray-1 mb-4">Alles für deinen Garten an einem Ort: Zimmerpflanzen, Bäumchen, Samen, Gartenaccessoires und saisonale Dekorationen..</p>

                  <div className="d-flex align-items-center">
                    <a href="https://www.google.com/maps/search/?api=1&query=Düsseldorfer+Landstraße+189,+47249+Duisburg,+Deutschland" target="_blank" rel="noopener noreferrer" className="medium font__size--16 text__16-1024 btn btn__action btn__orange color__white shadow rounded__50 pointer" style={{textDecoration: 'none'}}>Besuche unseren Laden</a>
                    <a href="tel:015208599686" className="medium font__size--16 text__16-1024 btn btn__action btn__outlined--black color__black shadow ml-3 no__opacity h__white rounded__50 pointer">Ruf uns an</a>
                  </div>

                  <div className="mt__3">
                    <div className="row">
                      <div className="col-xl-8 mb-5 mb-xl-0">
                        <GoogleReviewsWidget 
                          placeId={process.env.REACT_APP_GOOGLE_PLACE_ID}
                          maxReviews={1}
                          minRating={4}
                        />
                      </div>
                      <div className="col-xl-4 mt-auto position-relative">
                        {/* <div className="wrapper__info-name">
                          <div className="d-flex align-items-start">
                            <img src="./../images/Arrow 2.png" alt="" />
                            <span className="mali semi-bold font__size--16 text__16-1024">Featured Arrangement</span>
                          </div>
                        </div> */}
                        {/* <div className="wrapper__plan-card">
                          <img src="./../images/6.png" alt="" />
                          <div className="desc align-self-end mb-3">
                            <h3 className="semi-bold font__size--16 text__16-1024 mb-0">Seasonal Bouquet</h3>
                            <p className="medium font__size--16 text__16-1024 mb-2 color__orange">€25</p>
                            <a href="#!" className="medium font__size--12 text__12-1024 btn btn__orange shadow color__white">Order Now</a>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6"></div>
              </div>
            </div>
          </section>
        </div>


        {/* <section>
          <div className="container">
            <div className="row">
              <div className="col-md-6 text-center my-auto">
                <img src="./../images/Group 9.png" alt="" />
              </div>
              <div className="col-md-6 my-auto">
                <h2 className="normal font__size--50 text__50-1024 text__50-sm text__50-xs mb-3 quest">From Joy in Plants</h2>
                <p className="normal font__size--14 text__14-1024 color__gray-1 mb-0">We love it when we can bring you joy with flowers and plants. Our years of experience distinguish us, as well as our joy in daily interaction with flowers and plants, their wonderful scents and forms. We gladly advise you on the composition of your flowers - from decoratively bound bouquets to authentic creations.</p>

                <div className="wrapper__video-wrap res position-relative my-4">
                  {
                    !play ? <img src="./../images/_Play button.png" className="pointer play" onClick={() => {
                      video.current.play()
                      setPlay(!play)
                    }} alt="" /> : ""
                  }

                  <video ref={video} width="320" poster="./../images/Rectangle 3.png" height="240" controls>
                    <source src="./../images/03_oduvan_agro_hand_14_dut_oduvan_preview.mp4" type="video/mp4" />
                  </video>
                </div>

                <NavLink to="/about" className="font__size--16 text__16-1024 btn btn__outlined--black shadow no__opacity rounded__50 h__white">About us</NavLink>

              </div>
            </div>
          </div>
        </section> */}

        <section id="services" className="position-relative">
          <img src="./../images/Clip path group.png" className="images__leaf-3" alt="" />
          <div className="container position-relative">
            <div className="text-center mb-5">
              <h2 className="normal font__size--50 text__50-1024 text__50-sm text__50-xs">Unsere Blumen & Services</h2>
              <p className="normal font__size--14 text__14-1024 color__gray-1">In unserem schönen Geschäft beraten wir Sie gerne zu den neuesten Trends rund um Blumen – von Schnittblumen bis hin zu Topfpflanzen. <br className="d-none d-lg-block" /> Wir geben Ihnen Tipps zur richtigen Pflanzenpflege und zur optimalen Versorgung in jeder Jahreszeit.</p>
            </div>

            <div className="row mb-5">
              {
                serviceList.map((obj) => {
                  return <div className="col-lg-4 mb-4 mb-lg-0">
                    <div className="wrapper__grid-servie">
                      <svg className='mb-4 icon' width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_229_3197)">
                          <path d="M37.6554 0C29.6583 0 20 5.74219 20 12.8729C20 12.9147 20.0115 13.0336 20.0169 13.0753C20.0302 13.4802 20.309 13.8281 20.7014 13.9276C21.0911 14.0279 21.5058 13.8566 21.7099 13.5067C24.1007 9.42827 27.6074 6.29174 32.4326 3.91688C32.8792 3.69316 33.4314 3.89199 33.6479 4.33057C33.7553 4.54901 33.7713 4.79574 33.6932 5.02569C33.615 5.25563 33.4526 5.44117 33.2351 5.5477C27.8126 8.21796 24.1694 11.8931 22.0919 16.775C22.0581 16.8247 22.0154 16.8661 21.9913 16.9238C20.688 20.0665 20.0178 23.7961 20 28.0095C19.6792 27.1646 19.3005 26.3609 18.893 25.5772C19.6156 24.4687 20 23.2625 20 21.9638C20 14.8331 10.3417 9.09086 2.3446 9.09086C1.05205 9.09094 0 10.1429 0 11.4355C0 19.4327 5.74219 29.0909 12.8738 29.0909C14.6282 29.0909 16.2181 28.4044 17.615 27.0898C19.2082 30.4489 20 34.3936 20 39.091C20 39.5935 20.4066 40.0001 20.9091 40.0001C21.4116 40.0001 21.8182 39.5935 21.8182 39.091V28.1819C21.8182 24.624 22.3289 21.4735 23.2819 18.7426C24.4545 19.5725 25.7415 20 27.1271 20C34.2578 20 40 10.3418 40 2.34469C40 1.05205 38.948 0 37.6554 0Z" fill="#809D79" />
                        </g>
                        <defs>
                          <clipPath id="clip0_229_3197">
                            <rect width="40" height="40" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <h5 className='semi-bold font__size--24'>{obj.title}</h5>
                      <p className='normal font__size--14 color__gray-1 mb-0'>{obj.desc}</p>
                    </div>
                  </div>
                })
              }

            </div>
          </div>
        </section>


        <section id="about">
          <div className="container">
            <div className="row">
              <div className="col-md-6 order-md-1 order-12 my-auto">
                <h2 className="normal font__size--50 text__50-1024 text__50-sm text__50-xs mb-3">Warum WeroFlowers Gartencenter Duisburg wählen?</h2>
                <p className="normal font__size--16 text__16-1024 color__gray-1 mb-4">Ihr vertrauensvoller Partner für gesunde Pflanzen, Gartenbedarf und professionelle Pflanzenberatung in Duisburg seit Jahren.</p>

                <ul className="list__partner mb-4">
                  <li>
                    <div className="d-flex aling-items-start">
                      <div className="number normal font__size--16 text__16-1024 color__white bg__green"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg></div>
                      <div className="desc">
                        <h5 className="semi-bold font__size--24 text__24-1024">Fachkundige Pflanzenberatung</h5>
                        <p className="mb-0 normal font__size--14 text__14-1024 color__gray-1">Unser erfahrenes Gärtner-Team berät Sie kompetent bei Pflanzenwahl, Pflanzenpflege und Gartengestaltung. Kostenlose Beratung für alle Kunden in Duisburg.</p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="d-flex aling-items-start">
                      <div className="number normal font__size--16 text__16-1024 color__white bg__green"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg></div>
                      <div className="desc">
                        <h5 className="semi-bold font__size--24 text__24-1024">Gartencenter vor Ort in Duisburg</h5>
                        <p className="mb-0 normal font__size--14 text__14-1024 color__gray-1">Besuchen Sie uns persönlich an der Düsseldorfer Landstraße 189 in Duisburg. Sehen und wählen Sie Ihre Pflanzen selbst aus - mit kostenlosem Parkplatz direkt vor Ort.</p>
                      </div>
                    </div>
                  </li>
                </ul>



              </div>
              <div className="col-md-6 order-1 order-md-12 mb-4 my-md-auto text-center text-md-right position-relative">
                <img src="./../images/Group 10.png" alt="" />
              </div>
            </div>
          </div>
        </section>

        <section id="gallery" className="bg-light py-5">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 mx-auto text-center">
                <h2 className="normal font__size--50 text__50-1024 text__50-sm text__50-xs mb-4">Ein Blick in unser Geschäft</h2>
                <p className="normal font__size--16 text__16-1024 color__gray-1 mb-5">
                  Schauen Sie sich in unserem Laden um und lassen Sie sich von der Vielfalt unserer farbenfrohen Blumen, 
                  Arrangements und Pflanzendekorationen verzaubern. Wir freuen uns auf Ihren Besuch!
                </p>
                
                <img src="./../images/Group 11.png" className="w-100" alt="" />
              </div>
            </div>
          </div>
        </section>

        <SecBlog />

        <SecContact />

        <Footer />
      </div>
    </Fragment>
  );
};

export default LandingAlt;